<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">{{ modelo.id ? 'Editar' : 'Adicionar' }} Modelo de Mensagem</div>
            </div>
            <div class="card-body">
              <hr />
              <small class="text-muted d-block mb-1">
                Cadastro só de registro/controle do que já foi aprovado na Meta - o envio de templates de verdade ainda não está implementado.
              </small>
              <div class="row">
                <div class="col-md-12">
                  <form action />
                  <div class="form-row">
                    <div class="col-md-4">
                      <label for="nome">
                        <span class="required">*</span> Nome (igual ao da Meta):
                      </label>
                      <input autocomplete="new-password" type="text" id="nome" class="form-control" v-model="modelo.nome" />
                    </div>
                    <div class="col-md-2">
                      <label for="idioma">Idioma:</label>
                      <input type="text" id="idioma" class="form-control" v-model="modelo.idioma" />
                    </div>
                    <div class="col-md-3">
                      <label for="categoria">
                        <span class="required">*</span> Categoria:
                      </label>
                      <select v-model="modelo.categoria" class="form-control">
                        <option value="UTILITY">UTILITY</option>
                        <option value="MARKETING">MARKETING</option>
                        <option value="AUTHENTICATION">AUTHENTICATION</option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label for="status_meta">Status na Meta:</label>
                      <select v-model="modelo.status_meta" class="form-control">
                        <option value="pendente">Pendente</option>
                        <option value="aprovado">Aprovado</option>
                        <option value="rejeitado">Rejeitado</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-row mt-1">
                    <div class="col-md-9">
                      <label for="componentes">
                        Componentes (JSON, igual ao devolvido pela Meta):
                      </label>
                      <textarea id="componentes" class="form-control" rows="8" v-model="componentesTexto" placeholder='[{"type":"BODY","text":"..."}]'></textarea>
                    </div>
                    <div class="col-md-3">
                      <label for="status">Status:</label>
                      <select v-model="modelo.status" class="form-control">
                        <option value="1">Ativo</option>
                        <option value="0">Inativo</option>
                      </select>
                    </div>
                  </div>
                  <hr>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong> Campos obrigatórios</strong>
                  </span>
                  <div class="form-group mt-1">
                    <div class="block text-right">
                      <router-link to="/modelos_mensagem" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "modeloMensagemAdd",
  data() {
    return {
      modelo: {
        status: '1',
        idioma: 'pt_BR',
        categoria: 'UTILITY',
        status_meta: 'pendente',
      },
      componentesTexto: '',
      errors: undefined,
    };
  },
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "modelos_mensagem";

      if (self.componentesTexto.trim()) {
        try {
          self.modelo.componentes = JSON.parse(self.componentesTexto);
        } catch (e) {
          self.$message(null, "JSON de componentes inválido", "error");
          return;
        }
      }

      if (self.modelo.id) {
        self.modelo._method = "PUT"
        api += "/" + self.modelo.id;
      }

      axios
        .post(api, self.modelo)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/modelos_mensagem");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getModelo: function (id) {
      const self = this;
      const api = self.$store.state.api + "modelos_mensagem/" + id;

      axios
        .get(api)
        .then((response) => {
          self.modelo = response.data.data[0];
          if (self.modelo.componentes) {
            self.componentesTexto = JSON.stringify(self.modelo.componentes, null, 2);
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    if (id) {
      self.getModelo(id);
    }
  },
};
</script>
